var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPfGo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 59",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1181.1,-574.102)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,-1,1,6.12323e-17,0,1080)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pf-go",
    transform: "matrix(1,0,0,1,0,96.1552)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,1080,-6.61309e-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1112.65,628.548L1095.79,628.548L1111.21,603.816L1111.48,603.386L1111.21,602.957L1095.79,578.225L1112.65,578.225",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(217,219,233)",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,1080,-6.75016e-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1089.07,578.225L1089.52,578.225L1105.21,603.386L1089.52,628.548L1089.07,628.548L1089.07,578.225Z",
    style: {
      fill: "rgb(145,70,255)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,1080,-6.61309e-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1089.07,578.225L1089.52,578.225L1105.21,603.386L1089.52,628.548L1089.07,628.548",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(145,70,255)",
      strokeWidth: 2
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfGo);
export default __webpack_public_path__ + "static/media/pf-go.6d0ac8dcd37d1fea66cb4c839c37d166.svg";
export { ForwardRef as ReactComponent };